<template>
    <div v-if="hasAccess">
        <top-nav-bar goto="/"></top-nav-bar>
        <div class="app-menu-inner h-full">
            <div class="mx-auto py-10">
                <h2 class="text-center text-blue">
                    {{ trans('crewman::employee.title.pay_roll.pay_roll') }}
                </h2>
            </div>

            <div class="flex items-center justify-center rounded-lg m-4 pt-8 pb-2 bg-white shadow-lg">
                <div class="w-full md:w-1/2 flex flex-wrap sm:flex-wrap-reverse lg:flex-wrap mx-auto -mx-4">
                    <app-icon
                        v-for="item in menuItems"
                        :key="item.label"
                        :route="item.route"
                        :label="trans(item.trans)"
                        :icon="item.icon"
                        :badge="item.badge"
                    >
                    </app-icon>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CanAccessView from "../mixins/CanAccessView";
    import HasSortedMenuItems from "../mixins/HasSortedMenuItems";

    export default {
        mixins: [CanAccessView, HasSortedMenuItems],

        computed: {
            menuItems() {
                let subItems = [];
                let menuItem = this.sortedMenuItems.find(item => item.route === this.$router.currentRoute.path);
                if (menuItem && menuItem.subItems) {
                    subItems = menuItem.subItems;
                }
                return subItems.filter(item => item.display) || [];
            },
        },
    }
</script>
